/** biome-ignore-all lint/style/noMagicNumbers: better-auth apiKey defaults */
import {
  boolean,
  integer,
  pgTable,
  text,
  timestamp,
} from "drizzle-orm/pg-core";

export const user = pgTable("user", {
  banExpires: timestamp("ban_expires"),
  banned: boolean("banned"),
  banReason: text("ban_reason"),
  createdAt: timestamp("created_at").notNull(),
  email: text("email").notNull().unique(),
  emailVerified: boolean("email_verified").notNull(),
  id: text("id").primaryKey(),
  image: text("image"),
  name: text("name").notNull(),
  role: text("role"),
  twitterHandle: text("twitter_handle"),
  updatedAt: timestamp("updated_at").notNull(),
});

export const session = pgTable("session", {
  createdAt: timestamp("created_at").notNull(),
  expiresAt: timestamp("expires_at").notNull(),
  id: text("id").primaryKey(),
  impersonatedBy: text("impersonated_by"),
  ipAddress: text("ip_address"),
  token: text("token").notNull().unique(),
  updatedAt: timestamp("updated_at").notNull(),
  userAgent: text("user_agent"),
  userId: text("user_id")
    .notNull()
    .references(() => user.id, { onDelete: "cascade" }),
});

export const account = pgTable("account", {
  accessToken: text("access_token"),
  accessTokenExpiresAt: timestamp("access_token_expires_at"),
  accountId: text("account_id").notNull(),
  createdAt: timestamp("created_at").notNull(),
  id: text("id").primaryKey(),
  idToken: text("id_token"),
  password: text("password"),
  providerId: text("provider_id").notNull(),
  refreshToken: text("refresh_token"),
  refreshTokenExpiresAt: timestamp("refresh_token_expires_at"),
  scope: text("scope"),
  updatedAt: timestamp("updated_at").notNull(),
  userId: text("user_id")
    .notNull()
    .references(() => user.id, { onDelete: "cascade" }),
});

export const verification = pgTable("verification", {
  createdAt: timestamp("created_at"),
  expiresAt: timestamp("expires_at").notNull(),
  id: text("id").primaryKey(),
  identifier: text("identifier").notNull(),
  updatedAt: timestamp("updated_at"),
  value: text("value").notNull(),
});

// Better Auth apiKey plugin (@better-auth/api-key). Property names must match
// the plugin's field names so the drizzle adapter can map them.
export const apikey = pgTable("apikey", {
  configId: text("config_id").default("default").notNull(),
  createdAt: timestamp("created_at").notNull(),
  enabled: boolean("enabled").default(true),
  expiresAt: timestamp("expires_at"),
  id: text("id").primaryKey(),
  key: text("key").notNull(),
  lastRefillAt: timestamp("last_refill_at"),
  lastRequest: timestamp("last_request"),
  metadata: text("metadata"),
  name: text("name"),
  permissions: text("permissions"),
  prefix: text("prefix"),
  rateLimitEnabled: boolean("rate_limit_enabled").default(true),
  rateLimitMax: integer("rate_limit_max").default(10),
  rateLimitTimeWindow: integer("rate_limit_time_window").default(86_400_000),
  referenceId: text("reference_id").notNull(),
  refillAmount: integer("refill_amount"),
  refillInterval: integer("refill_interval"),
  remaining: integer("remaining"),
  requestCount: integer("request_count").default(0),
  start: text("start"),
  updatedAt: timestamp("updated_at").notNull(),
});
